import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * HTTP Security Interceptor
 *
 * Adds security headers to all HTTP requests:
 * - X-Requested-With: Helps prevent CSRF attacks
 * - Content-Type: Ensures proper content type for JSON requests
 *
 * Note: Full CSRF protection requires backend implementation of CSRF tokens.
 * This interceptor provides basic protection by identifying AJAX requests.
 */
export const httpSecurityInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {

  // Clone the request and add security headers
  const secureReq = req.clone({
    setHeaders: {
      // Add X-Requested-With header to identify AJAX requests
      // This helps prevent basic CSRF attacks
      'X-Requested-With': 'XMLHttpRequest'
    }
  });

  // For POST, PUT, PATCH, DELETE requests, ensure we're sending the right content type
  if (['POST', 'PUT', 'PATCH', 'DELETE'].includes(req.method)) {
    // If no content type is set and body is an object, set to JSON
    if (!req.headers.has('Content-Type') && typeof req.body === 'object') {
      return next(secureReq.clone({
        setHeaders: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      }));
    }
  }

  return next(secureReq);
};

/**
 * Usage:
 *
 * Add this interceptor to your app.config.ts providers:
 *
 * export const appConfig: ApplicationConfig = {
 *   providers: [
 *     provideHttpClient(
 *       withInterceptors([httpSecurityInterceptor])
 *     )
 *   ]
 * };
 */
